import Lenis from '@studio-freight/lenis'

class Scroller {
  constructor() {
    this.buttons = document.querySelectorAll('.js-scroll-to')

    this.documentScroller()
    this.scrollTo()
  }

  documentScroller() {
    window.lenis = new Lenis({
      duration: 1.2,
      easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)), //eslint-disable-line
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      smoothTouch: false,
      touchMultiplier: 2,
    })

    function raf(time) {
      window.lenis.raf(time)
      requestAnimationFrame(raf.bind(this))
    }

    requestAnimationFrame(raf.bind(this))
  }

  scrollTo() {
    this.buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        const target = e.currentTarget.getAttribute('data-scroll-target')
        const section = document.querySelector(`[data-scroll-section="${target}"]`)

        window.lenis.scrollTo(section)
      })
    })
  }
}

export default Scroller
